'use strict';

Object.defineProperty(exports, "__esModule", {
  value: true
});

var _createClass = function () { function defineProperties(target, props) { for (var i = 0; i < props.length; i++) { var descriptor = props[i]; descriptor.enumerable = descriptor.enumerable || false; descriptor.configurable = true; if ("value" in descriptor) descriptor.writable = true; Object.defineProperty(target, descriptor.key, descriptor); } } return function (Constructor, protoProps, staticProps) { if (protoProps) defineProperties(Constructor.prototype, protoProps); if (staticProps) defineProperties(Constructor, staticProps); return Constructor; }; }();

var _templateObject = _taggedTemplateLiteral(['\n  text-decoration: none;\n  background: ', ';\n  display: block;\n  border-right: 1px solid ', ';\n  color: ', ';\n  text-align: left;\n  padding: 1em 2em;\n  cursor: pointer;\n  font-weight: 520;\n  ', '\n\n  &:first-child {\n    border-top-left-radius: 5px;\n    border-bottom-left-radius: 5px;\n  }\n\n  &:last-child {\n    border: none;\n    border-top-right-radius: 5px;\n    border-bottom-right-radius: 5px;\n  }\n\n  &:hover {\n    color: ', ';\n  }\n'], ['\n  text-decoration: none;\n  background: ', ';\n  display: block;\n  border-right: 1px solid ', ';\n  color: ', ';\n  text-align: left;\n  padding: 1em 2em;\n  cursor: pointer;\n  font-weight: 520;\n  ', '\n\n  &:first-child {\n    border-top-left-radius: 5px;\n    border-bottom-left-radius: 5px;\n  }\n\n  &:last-child {\n    border: none;\n    border-top-right-radius: 5px;\n    border-bottom-right-radius: 5px;\n  }\n\n  &:hover {\n    color: ', ';\n  }\n']),
    _templateObject2 = _taggedTemplateLiteral(['\n\ttext-decoration: none;\n  display: block;\n  text-align: left;\n  cursor: pointer;\n  display: flex;\n  justify-content: space-between;\n\n  background: ', ';\n\n  color: ', ';\n\n  ', ';\n  padding: ', ';\n  margin: ', ';\n  border-radius: ', ';\n\n  span {\n    font-size: 12px;\n  }\n\n\t&:hover {\n\t\tcolor: ', ';\n\t\tbackground: ', ';\n\t}\n'], ['\n\ttext-decoration: none;\n  display: block;\n  text-align: left;\n  cursor: pointer;\n  display: flex;\n  justify-content: space-between;\n\n  background: ', ';\n\n  color: ', ';\n\n  ', ';\n  padding: ', ';\n  margin: ', ';\n  border-radius: ', ';\n\n  span {\n    font-size: 12px;\n  }\n\n\t&:hover {\n\t\tcolor: ', ';\n\t\tbackground: ', ';\n\t}\n']),
    _templateObject3 = _taggedTemplateLiteral(['\n  list-style: none;\n  display: flex;\n  justify-content: center;\n'], ['\n  list-style: none;\n  display: flex;\n  justify-content: center;\n']),
    _templateObject4 = _taggedTemplateLiteral(['\n  list-style: none;\n  float: left;\n  width: 30%;\n  height: 100%;\n  padding: ', ';\n  background: ', ';\n  li: first-child {\n\t\tborder-top: 1px solid ', ';\n\t}\n'], ['\n  list-style: none;\n  float: left;\n  width: 30%;\n  height: 100%;\n  padding: ', ';\n  background: ', ';\n  li: first-child {\n\t\tborder-top: 1px solid ', ';\n\t}\n']),
    _templateObject5 = _taggedTemplateLiteral(['\n  height: 100%;\n  overflow: hidden;\n  padding: 1em;\n'], ['\n  height: 100%;\n  overflow: hidden;\n  padding: 1em;\n']),
    _templateObject6 = _taggedTemplateLiteral(['\n\tfloat: right;\n  width: 65%;\n  height: 100%;\n  overflow: hidden;\n  padding: 1em;\n  margin: 0 1em;\n  border-radius: 10px;\n  background: ', ';\n'], ['\n\tfloat: right;\n  width: 65%;\n  height: 100%;\n  overflow: hidden;\n  padding: 1em;\n  margin: 0 1em;\n  border-radius: 10px;\n  background: ', ';\n']),
    _templateObject7 = _taggedTemplateLiteral(['\n  width: auto;\n'], ['\n  width: auto;\n']),
    _templateObject8 = _taggedTemplateLiteral(['\n  width: auto;\n\theight: 100%;\n\n  &:after {\n    clear: both;\n  }\n'], ['\n  width: auto;\n\theight: 100%;\n\n  &:after {\n    clear: both;\n  }\n']),
    _templateObject9 = _taggedTemplateLiteral(['\n  display: flex;\n'], ['\n  display: flex;\n']),
    _templateObject10 = _taggedTemplateLiteral(['\n  width: auto;\n  margin-top: 5px;\n'], ['\n  width: auto;\n  margin-top: 5px;\n']),
    _templateObject11 = _taggedTemplateLiteral(['\n  margin-left: 10px;\n  font-size: 1.8em;\n'], ['\n  margin-left: 10px;\n  font-size: 1.8em;\n']);

var _react = require('react');

var _react2 = _interopRequireDefault(_react);

var _propTypes = require('prop-types');

var _propTypes2 = _interopRequireDefault(_propTypes);

var _styledComponents = require('styled-components');

var _styledComponents2 = _interopRequireDefault(_styledComponents);

var _color = require('../color');

var _color2 = _interopRequireDefault(_color);

function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }

function _classCallCheck(instance, Constructor) { if (!(instance instanceof Constructor)) { throw new TypeError("Cannot call a class as a function"); } }

function _possibleConstructorReturn(self, call) { if (!self) { throw new ReferenceError("this hasn't been initialised - super() hasn't been called"); } return call && (typeof call === "object" || typeof call === "function") ? call : self; }

function _inherits(subClass, superClass) { if (typeof superClass !== "function" && superClass !== null) { throw new TypeError("Super expression must either be null or a function, not " + typeof superClass); } subClass.prototype = Object.create(superClass && superClass.prototype, { constructor: { value: subClass, enumerable: false, writable: true, configurable: true } }); if (superClass) Object.setPrototypeOf ? Object.setPrototypeOf(subClass, superClass) : subClass.__proto__ = superClass; }

function _taggedTemplateLiteral(strings, raw) { return Object.freeze(Object.defineProperties(strings, { raw: { value: Object.freeze(raw) } })); }

var HorizontalStyledLi = _styledComponents2.default.li(_templateObject, _color2.default.purple_accent, _color2.default.blue_accent, _color2.default.blue_main, function (props) {
  return props.activeClass === 'is-active' ? 'color: ' + _color2.default.orange_main + ';' : '';
}, _color2.default.orange_main);

var VerticalStyledLi = _styledComponents2.default.li(_templateObject2, function (props) {
  var isDark = props.theme === 'dark';
  var isActive = props.activeClass === 'is-active';
  if (isDark) return isActive ? _color2.default.blue_main : _color2.default.white;
  return _color2.default.purple_accent;
}, function (props) {
  var isDark = props.theme === 'dark';
  var isActive = props.activeClass === 'is-active';
  if (isDark) return isActive ? _color2.default.white : _color2.default.grey_main;
  if (!isDark) return isActive ? _color2.default.orange_main : _color2.default.blue_main;
}, function (props) {
  var isDark = props.theme === 'dark';
  if (isDark) return 'border: 1px solid ' + _color2.default.blue_accent + ';';
  return 'border-bottom: 1px solid ' + _color2.default.blue_accent + ';';
}, function (props) {
  return props.theme === 'dark' ? '1em' : '1.7em';
}, function (props) {
  return props.theme === 'dark' ? '0.5em 0' : '0';
}, function (props) {
  return props.theme === 'dark' ? '10px' : '0';
}, _color2.default.white, _color2.default.blue_accent);

var HorizontalStyledUl = _styledComponents2.default.ul(_templateObject3);

var VerticalStyledUl = _styledComponents2.default.ul(_templateObject4, function (props) {
  return props.theme === 'dark' ? '0' : '50px 0px 0px';
}, function (props) {
  return props.theme === 'dark' ? _color2.default.white : _color2.default.purple_accent;
}, _color2.default.blue_accent);

var HorizontalTabContent = _styledComponents2.default.div(_templateObject5);

var VerticalTabContent = _styledComponents2.default.div(_templateObject6, function (props) {
  return props.theme === 'dark' ? _color2.default.purple_accent : '#FFF';
});

var HorizontalTabContainer = _styledComponents2.default.div(_templateObject7);

var VerticalTabContainer = _styledComponents2.default.div(_templateObject8);

var Container = _styledComponents2.default.div(_templateObject9);

var Label = _styledComponents2.default.div(_templateObject10);

var Icon = _styledComponents2.default.div(_templateObject11);

var MozartTab = function (_Component) {
  _inherits(MozartTab, _Component);

  function MozartTab() {
    _classCallCheck(this, MozartTab);

    return _possibleConstructorReturn(this, (MozartTab.__proto__ || Object.getPrototypeOf(MozartTab)).apply(this, arguments));
  }

  _createClass(MozartTab, [{
    key: 'getData',
    value: function getData(data) {
      return data.map(function (tab, index) {
        return _react2.default.createElement(
          'div',
          { key: index, icon: tab.icon, label: tab.name, onClick: tab.onClick },
          tab.content
        );
      });
    }
  }, {
    key: 'render',
    value: function render() {
      var _props = this.props,
          data = _props.data,
          customStyle = _props.customStyle,
          horizontal = _props.horizontal,
          defaultSelect = _props.defaultSelect,
          theme = _props.theme,
          themeStyle = _props.themeStyle,
          themeId = _props.themeId,
          resetValue = _props.resetValue;

      var DATA = this.getData(data);
      return horizontal ? _react2.default.createElement(
        HorizontalTabs,
        { testId: this.props.testId, themeStyle: themeStyle, style: customStyle, selected: defaultSelect || 0, resetValue: resetValue || 0, themeId: themeId },
        DATA
      ) : _react2.default.createElement(
        VerticalTabs,
        { testId: this.props.testId, themeStyle: themeStyle, theme: theme, style: customStyle, selected: defaultSelect || 0, resetValue: resetValue || 0, themeId: themeId },
        DATA
      );
    }
  }]);

  return MozartTab;
}(_react.Component);

MozartTab.propTypes = {
  /** qa attribute */
  testId: _propTypes2.default.string,
  /** theme attribute */
  themeId: _propTypes2.default.string,
  /** data is object array includes label {name, content, icon, onClick} */
  data: _propTypes2.default.array,
  /** defaultSelect is index of data array */
  defaultSelect: _propTypes2.default.number,
  /** override style */
  customStyle: _propTypes2.default.object,
  /** horizontal if true horizontal tab otherwise vertical */
  horizontal: _propTypes2.default.bool,
  /** theme */
  theme: _propTypes2.default.string,
  /** theme style */
  themeStyle: _propTypes2.default.object,
  resetValue: _propTypes2.default.number
};
MozartTab.defaultProps = {
  defaultSelect: 0,
  horizontal: false,
  testId: 'MozartTab',
  themeId: 'MozartTab'
};
exports.default = MozartTab;

var HorizontalTabs = function (_Component2) {
  _inherits(HorizontalTabs, _Component2);

  function HorizontalTabs(props) {
    _classCallCheck(this, HorizontalTabs);

    var _this2 = _possibleConstructorReturn(this, (HorizontalTabs.__proto__ || Object.getPrototypeOf(HorizontalTabs)).call(this, props));

    _this2.state = { selected: _this2.props.selected };
    return _this2;
  }

  _createClass(HorizontalTabs, [{
    key: 'componentWillReceiveProps',
    value: function componentWillReceiveProps(nextProps) {
      if (this.props.resetValue !== nextProps.resetValue) {
        this.state.selected = 0;
      }
    }
  }, {
    key: 'labels',
    value: function labels(child, idx) {
      return _react2.default.createElement(
        HorizontalStyledLi,
        {
          className: this.state.selected === idx ? 'active' : '',
          activeClass: this.state.selected === idx ? 'is-active' : '',
          role: 'tab',
          key: idx,
          onClick: this.onClick.bind(this, idx, child.props.onClick),
          'aria-controls': 'panel' + idx
        },
        _react2.default.createElement(
          Container,
          null,
          child.props.label && _react2.default.createElement(
            Label,
            null,
            child.props.label
          ),
          child.props.icon && _react2.default.createElement(
            Icon,
            null,
            child.props.icon
          )
        )
      );
    }
  }, {
    key: 'renderTitles',
    value: function renderTitles() {
      return _react2.default.createElement(
        HorizontalStyledUl,
        { role: 'tablist' },
        this.props.children.map(this.labels.bind(this))
      );
    }
  }, {
    key: 'onClick',
    value: function onClick(index, onClickFunc) {
      this.setState({
        selected: index
      }, function () {
        if (onClickFunc) {
          onClickFunc();
        }
      });
    }
  }, {
    key: 'render',
    value: function render() {
      var _this3 = this;

      var _props2 = this.props,
          customStyle = _props2.customStyle,
          themeStyle = _props2.themeStyle,
          testId = _props2.testId,
          themeId = _props2.themeId;

      return _react2.default.createElement(
        HorizontalTabContainer,
        { 'data-qa': testId, customStyle: customStyle, 'data-theme': 'MozartTab-Horizontal' },
        this.renderTitles(),
        _react2.default.createElement(
          HorizontalTabContent,
          { 'data-theme': 'MozartHorizontalTabContent', style: themeStyle },
          this.props.children.map(function (item, index) {
            return _react2.default.createElement(
              'div',
              { style: _this3.state.selected === index ? {} : { display: 'none' } },
              item
            );
          })
        )
      );
    }
  }]);

  return HorizontalTabs;
}(_react.Component);

HorizontalTabs.PropTypes = {
  /** qa attribute */
  testId: _propTypes2.default.string,
  /** theme attribute */
  themeId: _propTypes2.default.string,
  customStyle: _propTypes2.default.object,
  resetValue: _propTypes2.default.number
};

var VerticalTabs = function (_Component3) {
  _inherits(VerticalTabs, _Component3);

  function VerticalTabs(props) {
    _classCallCheck(this, VerticalTabs);

    var _this4 = _possibleConstructorReturn(this, (VerticalTabs.__proto__ || Object.getPrototypeOf(VerticalTabs)).call(this, props));

    _this4.state = { selected: _this4.props.selected };
    return _this4;
  }

  _createClass(VerticalTabs, [{
    key: 'componentWillReceiveProps',
    value: function componentWillReceiveProps(nextProps) {
      if (this.props.resetValue !== nextProps.resetValue) {
        this.state.selected = 0;
      }
    }
  }, {
    key: 'labels',
    value: function labels(child, idx) {
      var theme = this.props.theme;

      var isDark = theme === 'dark';
      return _react2.default.createElement(
        VerticalStyledLi,
        {
          theme: theme,
          className: this.state.selected === idx ? 'active' : '',
          activeClass: this.state.selected === idx ? 'is-active' : '',
          role: 'tab',
          key: idx,
          onClick: this.onClick.bind(this, idx, child.props.onClick),
          'aria-controls': 'panel' + idx },
        _react2.default.createElement(
          'div',
          null,
          child.props.label
        ),
        isDark && _react2.default.createElement(
          'div',
          null,
          _react2.default.createElement('span', { className: 'icon-Right' })
        )
      );
    }
  }, {
    key: 'renderTitles',
    value: function renderTitles() {
      var theme = this.props.theme;

      return _react2.default.createElement(
        VerticalStyledUl,
        { theme: theme, role: 'tablist' },
        this.props.children.map(this.labels.bind(this))
      );
    }
  }, {
    key: 'onClick',
    value: function onClick(index, onClickFunc) {
      this.setState({
        selected: index
      }, function () {
        if (onClickFunc) {
          onClickFunc();
        }
      });
    }
  }, {
    key: 'render',
    value: function render() {
      var _this5 = this;

      var _props3 = this.props,
          customStyle = _props3.customStyle,
          theme = _props3.theme,
          themeStyle = _props3.themeStyle,
          testId = _props3.testId,
          themeId = _props3.themeId;

      return _react2.default.createElement(
        VerticalTabContainer,
        { 'data-qa': testId, customStyle: customStyle, 'data-theme': 'MozartTab-Vertical' },
        this.renderTitles(),
        _react2.default.createElement(
          VerticalTabContent,
          { 'data-theme': 'MozartVerticalTabContent', theme: theme, style: themeStyle },
          this.props.children.map(function (item, index) {
            return _react2.default.createElement(
              'div',
              { style: _this5.state.selected === index ? {} : { display: 'none' } },
              item
            );
          })
        )
      );
    }
  }]);

  return VerticalTabs;
}(_react.Component);

VerticalTabs.PropTypes = {
  /** qa attribute */
  testId: _propTypes2.default.string,
  /** theme attribute */
  themeId: _propTypes2.default.string,
  customStyle: _propTypes2.default.object,
  theme: _propTypes2.default.string,
  resetValue: _propTypes2.default.number
};


//////////////////
// WEBPACK FOOTER
// ./node_modules/@pgforsta/mozart_ui/lib/components/Mozart/MozartTab/MozartTab.js
// module id = 1950
// module chunks = 1